import DOMPurify from 'dompurify'

export const isExternalCompany = (organization_type) => organization_type === 'STD'

export function isEmpty(value) {
  return value === undefined || value === null || value === ''
}

export function humanize(str) {
  let i
  const frags = str?.split(str?.includes('_') ? '_' : '-')
  for (i = 0; i < frags?.length || 0; i += 1) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
  }
  return frags?.join(' ')
}

export const isUserEmailFromElevateOrGsquad = (email) =>
  email.includes('@elevatesecurity.com') || email.includes('@gsquad.io')

/**
 * It takes a dirty HTML as input and return a clean string
 * free of any svg, svg filters, mathML and HTML
 *
 * @param {string} dirty
 */
export const sanitizeContent = (dirty) =>
  DOMPurify.sanitize(dirty, {
    USE_PROFILES: { svg: false, svgFilters: false, mathMl: false, html: false }
  })

export const transformServicesArrayToObj = (services) => {
  const servicesObject = {}
  services.forEach((service) => {
    const result = {
      entitlement: service.entitlement,
      visibility: service.visibility,
      name: service.service.name,
      description: service.service.description,
      licenses: service.licenses,
      usedLicenses: service.used_licenses,
      active: service.service.active
    }

    servicesObject[result.name] = result
  })
  return servicesObject
}

export const getRegionFromUrl = (domain, preText = '') => {
  const url = domain?.split('.')
  let region = ''
  if (url.length > 3 && domain?.indexOf('-pr-') === -1) {
    region = `${url[1]}`
  }
  return region ? `${preText}${region}` : region
}

/**
 * Certain characters treated as HTML are escaped in order to render correctly
 * Modified from https://github.com/component/escape-html/blob/master/index.js
 * Further reading on what characters to escape can be found: https://mina86.com/2021/no-you-dont-need-to-escape-that/
 * free of any svg, svg filters, mathML and HTML
 */
export const escapeHtml = (string) => {
  const matchHtmlRegExp = /["'&<>`]/
  // eslint-disable-next-line prefer-template
  const str = '' + string
  const match = matchHtmlRegExp.exec(str)

  if (!match) {
    return str
  }

  let escape
  let html = ''
  let index = 0
  let lastIndex = 0

  for (index = match.index; index < str.length; index += 1) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&#34;'
        break
      case 38: // &
        escape = '&#38;'
        break
      case 39: // '
        escape = '&#39;'
        break
      case 60: // <
        escape = '&#60;'
        break
      case 62: // >
        escape = '&#62;'
        break
      case 96: // `
        escape = '&#96;'
        break
      default:
        // eslint-disable-next-line no-continue
        continue
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index)
    }

    lastIndex = index + 1
    html += escape
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html
}
